import Vue from 'vue';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css'; // import styles
import 'quill/dist/quill.snow.css'; // for snow theme

let editorOpts = {
    modules: {
        toolbar: [
            [{ header: [2, 3, 4, false] }],
            ['bold', 'italic', 'blockquote'],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['clean'],
            ['video'],
        ],
        clipboard: {
            matchVisual: false
        }
    },
    placeholder: 'Write Something Inspiring...'
};

Vue.use(VueQuillEditor, editorOpts);
